(ns practitest.frontend.components2.add-entities
  (:require [practitest.frontend.pt-ts-bridge :as pt-ts :refer [FiltersPanel]]
            [practitest.frontend.common-entities.index :refer [panel-config]]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.i18n :refer [format-translation
                                                     get-translation]]
            [practitest.frontend.components2.resize-panel :refer [panel-group panel-resizeable panel-resize-handle]]
            [practitest.frontend.components.grid.localstorage :as grid-storage]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.modal :as modal]
            [practitest.frontend.components.spinners :as spinners]
            [practitest.frontend.components2.buttons :as buttons]
            [practitest.frontend.components2.grid :as grid2]
            [practitest.frontend.events :as events]
            [practitest.frontend.folders :as folders]
            [practitest.frontend.subs :as subs]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]))

;;; filters view
;; NOTE: we'll be developing a new filters tree component soon
;;       it will be used in index pages, popups, filter selectors (in dashboards, reports)
(defn- tree-node-element
  [local-state-updating props level node]
  (let [{:keys [children id]} node
        has-children? (seq children)
        ;; TODO: Should be expanded when selected item is inside the tree
        expanded? (contains? (:expanded @local-state-updating) id)
        selected? (= id (:id @(:current-item props)))
        on-item-selected (:on-item-selected props)]
    (concat [^{:key id}
             [:li.list-group-item
              {:style {:margin-left (str level "em")}
               :class (dom/classes-pairs
                       :list-group-item-info selected?)
               :on-click (fn [_e]
                           (when on-item-selected
                             (on-item-selected node)))}

              (when has-children?
                ;; TODO: make this span bigger (to make clicking easier) / move on-click to list-item ?
                [:span.clickable
                 {:style {:height "100%"}
                  :on-click (when has-children?
                              (fn [e]
                                (dom/prevent-default e)
                                (dom/stop-propagation e)
                                (if expanded?
                                  (swap! local-state-updating update :expanded disj id)
                                  (swap! local-state-updating update :expanded conj id))))}

                 (if expanded?
                   [icons/svg-chevron-down]
                   [icons/svg-chevron-right])])
              ;; TODO: use css for this
              " "
              [:a {:href "#"
                   :on-click (fn [e]
                               (dom/prevent-default e))}
               (:name node)]]]

            (when (contains? (:expanded @local-state-updating) id)
              (mapcat #(tree-node-element local-state-updating props (inc level) %)
                      children)))))

(defn filters-view [_]
  (fn [{:keys [on-item-selected on-folder-selected module]}]
    (when (not= module "Milestone")
      (let [user-id (:id @(re-frame/subscribe [::subs/current-user]))
            project-id (:id @(re-frame/subscribe [::subs/current-project]))
            all-entity-fields (re-frame/subscribe [::subs/all-entity-fields])
            options @(re-frame/subscribe [::subs/options])]
        (into [:div.filters-view.overlay-parent
               [:> FiltersPanel {:scope {:module  module  :user-id (str user-id) :project-id (str project-id)}
                                 :isDataReady  (boolean @all-entity-fields)
                                 :notifyFilterChanged #(on-item-selected (js->clj % :keywordize-keys true))
                                 :notifyFolderChanged #(on-folder-selected (js->clj % :keywordize-keys true))
                                 :settings {:cacheVersion (aget js/window "_pt" "client_version")
                                            :enableSearch true
                                            :disableBookmarks true
                                            :maxNumberOfFavorites (aget js/window "_pt" "max_number_of_favorites")
                                            :enableSettings false
                                            :enableFolders (folders/is-folders-enabled module)
                                            :enableAddFilters false
                                            :resizable false}}]])))))
(defn add-entities [_]
  (fn [{:keys [show-views?
               local-state-updating
               selected-entities
               fetching-filters?
               current-filter-selected
               set-current-filter
               set-current-folder
               added-tests
               module
               table-id
               disabled-row?
               disabled-row-tooltip
               disabled-select-all?
               disabled-select-all-tooltip
               added-row-tooltip
               allows-added-rows?
               alt-highlight-row?
               selected?
               all-selected?
               expandable-row?
               expanded-row?
               expandable-row-component
               on-expand-row-click
               on-page-changed
               on-filter-changed
               toggle-selection
               toggle-selection-page
               toggle-selection-on-filter-change?
               current-page
               total-count
               loading?
               data
               full-data?
               filters
               columns
               on-query-changed
               get-field-props]}]
    (let [show-views? (and @show-views? (not= module "Milestone"))]
      [:div.h-100
       [:div.filter-tree-and-grid-container
        [panel-group {:auto-save-id "index-content-panel"}

          [panel-resizeable {:default-size (get-in panel-config [:filters :default-size])
                        :min-size (get-in panel-config [:filters :min-size])}
          (when show-views?
            [filters-view {:filters filters
                           :current-item current-filter-selected
                           :fetching? fetching-filters?
                           :local-state-updating local-state-updating
                           :selected-entities selected-entities
                           ;; TODO: debounce events
                           :module module
                           :on-item-selected (reagent/partial set-current-filter local-state-updating)
                           :on-folder-selected (reagent/partial set-current-folder local-state-updating)}])]
          [panel-resize-handle]
          [panel-resizeable {:default-size (get-in panel-config [:grid :default-size])
                        :min-size (get-in panel-config [:grid :min-size])}
          [:div.full-width.h-100
           [:div.milestone-link-entities-grid.overlay-parent.h-100
            [grid2/grid
             {:columns @columns
              :fields  @(re-frame/subscribe [::subs/fields])
              :show-edit-columns? true

              :loading? @loading?
              :data @data
              :grid-state local-state-updating
              :local-state-updating local-state-updating
              :disabled-row? disabled-row?
              :disabled-row-tooltip disabled-row-tooltip
              :disabled-select-all? disabled-select-all?
              :disabled-select-all-tooltip disabled-select-all-tooltip
              :alt-highlight-row? alt-highlight-row?
              ;; TODO: well, it's not tests anymore, we should pick some better name here
              ;;       we'll do it when we refactor grid2 (there is other instance-specific stuff there right now)
              :added-tests added-tests
              :allows-added-rows? allows-added-rows?
              :added-row-tooltip added-row-tooltip
              :selected? selected?
              :all-selected? all-selected?
              :toggle-selection toggle-selection
              :toggle-selection-page toggle-selection-page
              :toggle-selection-on-filter-change? toggle-selection-on-filter-change?
              :expandable-row? expandable-row?
              :expanded-row? expanded-row?
              :expandable-row-component expandable-row-component
              :on-expand-row-click on-expand-row-click
              :on-page-changed on-page-changed
              :on-filter-changed on-filter-changed
              :current-page @current-page
              :total-count @total-count
              :full-data? @full-data?
              :on-query-changed (reagent/partial on-query-changed)

              :per-page-save (reagent/partial grid-storage/save-per-page table-id)
              :per-page-load (reagent/partial grid-storage/load-per-page table-id)

              :resizable? true
              :columns-settings-save (reagent/partial grid-storage/save-column-settings table-id)
              :columns-settings-load (reagent/partial grid-storage/load-column-settings table-id)
              :columns-widths-save (reagent/partial grid-storage/save-column-sizes table-id)
              :columns-widths-load (reagent/partial grid-storage/load-column-sizes table-id)

              ;; For filters
              :get-field-props get-field-props}]]]]]]])))

(defn add-entities-button [{:keys [local-state-updating]}]
  (fn [{:keys [on-add-entities
               adding-entities?
               add-entities-button-label
               selected-entities
               total-count]}]
    (let [selected-view (:selected-view-id @local-state-updating)
          selected-entities-count (if selected-view total-count (count @selected-entities))
          disabled? (or adding-entities? (zero? selected-entities-count))]
      [buttons/button
       {:disabled? disabled?
        :primary? true
        :toolbar? true
        :on-click (fn [_e]
                    (when on-add-entities
                      (on-add-entities @selected-entities)))
        :icon (if adding-entities?
                [spinners/inline-spinner-border]
                [icons/add-plus-icon])
        :text (format-translation
               add-entities-button-label
               :n selected-entities-count)
        :size "large"}])))

(defn action-buttons [{:keys [close-dialog warning-message] :as grid-props}]
  [:div
   (when-let [warning (and warning-message (warning-message))]
     [:div.warning-message
      [:strong (get-translation "generic.warning.note" "Note: ")]
      warning])
   [:div.right-selection.nowrap.add-cancel-component
    [buttons/button
     {:on-click close-dialog
      :toolbar? true
      :text (get-translation "generic.button.cancel" "Cancel")
      :size "large"}]
    [add-entities-button grid-props]]])

(defn add-entities-dialog [container-ref
                           {:keys [title show? hide! module] :as grid-props}]
  (let [grid-state (reagent/atom {:expanded #{}})]
    (fn [_ grid-props]
      (let [grid-props (merge grid-props
                              {:close-dialog hide!
                               :local-state-updating grid-state
                               :fetching-filters? (re-frame/subscribe [::subs/progress? ::events/fetch-filters])})]
        [modal/bootstrap-modal
         {:is-open? @show?
          :on-request-close hide!
          :container-ref container-ref
          ;; TODO: generic class?
          :class "add-instances-modal"
          :close-button? true}

         ;; header
         [:span {:style {:font-weight 600}} title]

         ;; body
         [add-entities grid-props]

         ;; footer
         [action-buttons grid-props]]))))

(comment
  (require '[re-frame.db])

  (tap> re-frame.db/app-db)

  (tap> (re-frame/subscribe [:practitest.frontend.components.grid.subs/selection [:milestone :link-requirements-state]])))
